import * as React from "react";

const MobileAccordian3 = ({ color = "#80FF00" }) => (
  <svg
    width={326}
    height={42}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.67.21h309.85V23.17L312.246 41H1V14.13L15.67.21Z"
      fill="#070707"
    />
    <path
      d="M94.266.21H325.52V23.17L312.246 41h-9.88M172.73 41H1V14.13L15.67.21h17.36"
      stroke={color}
      strokeWidth={0.386}
    />
  </svg>
);

export default MobileAccordian3;
